import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dashboardImage from "../../../assets/images/illustrations/dashboard.png";
import { UpcomingGamesList } from "../../../components/game";
import Button from "../../../components/ui/Button";
import Text from "../../../components/ui/Text";
import { DESKTOP_LAYOUTS } from "../../../constants/spacing";
import { useToast } from "../../../contexts/ToastContext";
import apiService from "../../../services/api";

export const YourUpcomingGames = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const { showToast } = useToast();

  const getGames = async () => {
    try {
      setLoading(true);

      const response = await apiService.fetchUserGames({
        from: new Date().getTime(),
      });

      setGames(response.data);
    } catch (error) {
      showToast(error.error, "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getGames();
  }, []);
  return (
    <Box sx={{ flex: 1 }}>
      <Box
        sx={{
          ...DESKTOP_LAYOUTS.contentCard,
          height: "fit-content",
        }}
      >
        <Text variant="paragraph" sx={{ fontSize: "20px", mb: 3 }}>
          Your upcoming games
        </Text>

        {loading ? (
          <Box sx={{ textAlign: "center", py: 2 }}>
            <Text variant="paragraph3">Loading upcoming games...</Text>
          </Box>
        ) : games.length > 0 ? (
          <Box sx={{ pt: 2 }}>
            <UpcomingGamesList games={games} filledSevenDays />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              pt: 4,
            }}
          >
            <Box
              component="img"
              src={dashboardImage}
              alt="No upcoming games"
              sx={{
                width: "120px",
                height: "auto",
                mb: 2,
              }}
            />
            <Text
              variant="paragraph3"
              sx={{
                textAlign: "center",
                mb: 3,
                color: "#666",
              }}
            >
              You don't have any upcoming games
            </Text>
            <Button
              component={Link}
              variant="primary"
              sx={{ width: "100%" }}
              to="/upcoming"
            >
              Search for a game
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
